// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"-popup-wrapper-3qFGrL-","inner":"-popup-inner-3SyHv9-","start":"-popup-start-3OqcJo-","modal":"-popup-modal-BcbA6V-"};